import React, { memo } from 'react';
import { FormControl, FormControlProps } from '@mui/material';

const FormControlComponent = ({
  children,
  ...props
}: FormControlProps<() => JSX.Element>): React.ReactElement => {
  return (
    <FormControl {...props} size="small">
      {children}
    </FormControl>
  );
};

FormControlComponent.displayName = 'FormControl Field component';

export const PmiFormControl = memo(FormControlComponent) as typeof FormControlComponent;
